export default function About() {
  const stats = [
    { number: '1965', label: '創立於巴黎' },
    { number: '10,000+', label: '滿意客戶' },
    { number: '98%', label: '客戶好評率' },
    { number: '2-3年', label: '永生花保存期' }
  ];

  return (
    <section id="about" className="py-16 sm:py-20 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 sm:gap-12 md:gap-16 items-center">
          <div>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#2C2C2C] mb-4 sm:mb-6">
              巴黎美學，日常綻放
            </h2>
            <div className="space-y-4 sm:space-y-5 text-sm sm:text-base text-gray-700 leading-relaxed">
              <p>
                <strong>Monceau Fleurs</strong> 創立於 1965 年巴黎蒙梭公園旁，以其獨特的「開放式花店」概念聞名全球。這場跨國的美學合作，背後的核心推手正是品牌亞洲區的靈魂人物：<strong>柴崎會長（Kenji Shibasaki）</strong>。
              </p>
              <p>
                柴崎會長憑藉敏銳的商業直覺與對花藝的熱愛，首先將此模式成功在日本扎根（如自由之丘、銀座店），證明了法式生活美學在亞洲市場的巨大潛力。
              </p>
              <p>
                在台灣，我們由<strong>美語花語股份有限公司（Belle Fiori）</strong>代理引進並營運。會長的經營哲學非常明確：「花卉不應是遙不可及的奢侈品，而是每個人都能隨手帶回家的溫暖與幸福。」
              </p>
              <p>
                美語花語團隊在會長的指導下，積極推動數位轉型與服務優化。無論是透過社群經營，還是堅持「價格透明、開架挑選」的原則，都是為了落實會長最初的願景：<strong>讓買花像買麵包一樣自然</strong>。
              </p>
              <p className="text-[#14B8A6] font-semibold">
                從巴黎的街頭到台灣的日常，Monceau Fleurs 不僅是一間花店，更是一個傳遞情感的空間。每一束花，都承載著跨越國界的優雅與對生活的講究。
              </p>
            </div>
          </div>

          <div className="relative mt-8 lg:mt-0">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/c2aa9f2411f356d7a545e0c3ed602d98.jpg"
                alt="Monceau Fleurs 巴黎花店"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -left-4 sm:-bottom-8 sm:-left-8 bg-[#14B8A6] text-white p-6 sm:p-8 rounded-2xl shadow-xl">
              <div className="text-3xl sm:text-4xl font-bold mb-1">1965</div>
              <div className="text-xs sm:text-sm font-medium">創立於巴黎</div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6 md:gap-8 mt-16 sm:mt-20 md:mt-24">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="text-center p-5 sm:p-6 md:p-8 bg-[#FAFAFA] rounded-2xl hover:shadow-lg transition-shadow duration-300"
            >
              <div className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#14B8A6] mb-2 sm:mb-3">
                {stat.number}
              </div>
              <div className="text-xs sm:text-sm text-gray-600 font-medium">
                {stat.label}
              </div>
            </div>
          ))}
        </div>

        {/* 品牌故事區塊 */}
        <div className="mt-16 sm:mt-20 md:mt-24 bg-gradient-to-br from-[#FAFAFA] to-white rounded-3xl p-8 sm:p-10 md:p-12 shadow-lg">
          <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#2C2C2C] mb-6 sm:mb-8 text-center">
            美語花語：落實在地化的法式優雅
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 mb-8 sm:mb-10">
            <div className="bg-white p-6 sm:p-8 rounded-2xl shadow-md">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-[#14B8A6] rounded-full flex items-center justify-center mr-4">
                  <i className="ri-store-2-line text-white text-xl"></i>
                </div>
                <h4 className="text-lg sm:text-xl font-bold text-[#2C2C2C]">高端旗艦店</h4>
              </div>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                <strong>信義 A8 與 Diamond Towers</strong>：鎖定流行指標與高端客群，展現鮮花的時尚魅力。
              </p>
            </div>
            <div className="bg-white p-6 sm:p-8 rounded-2xl shadow-md">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-[#14B8A6] rounded-full flex items-center justify-center mr-4">
                  <i className="ri-plant-line text-white text-xl"></i>
                </div>
                <h4 className="text-lg sm:text-xl font-bold text-[#2C2C2C]">文青生活店</h4>
              </div>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                <strong>南西店與天母店</strong>：針對文青與外籍客群，將永生花、植栽與茶文化結合，營造如市集般的親切感。
              </p>
            </div>
          </div>
          <div className="text-center">
            <p className="text-sm sm:text-base text-gray-700 leading-relaxed max-w-3xl mx-auto">
              美語花語團隊在柴崎會長的指導下，正積極推動數位轉型與服務優化。無論是透過 LINE 與 IG 的社群經營，還是堅持「價格透明、開架挑選」的原則，都是為了落實會長最初的願景：<strong className="text-[#14B8A6]">讓買花像買麵包一樣自然</strong>。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
